import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { CoreApiService } from "src/app/core/core-api.service";
import { CodigoTransacaoService } from "src/app/shared/services/codigo-transacao.service";
import { generateUUID } from "src/app/shared/utils/functions/codigo-transacao.model";
import { endpoints } from "src/environments/endpoints";

@Injectable({
  providedIn: "root",
})
export class PerfilService {
  constructor(
    private apiService: CoreApiService,
    private codigo: CodigoTransacaoService
  ) {}

  listarEmpresas(documentoIdentificador: string) {
    let query = {
      documentoIdentificador,
    };

    return this.apiService.get(endpoints.listarEmpresas, { query });
  }

  listarEmpresa(cnpj:string, documentoIdentificador: string) {
    let query = {
      documentoIdentificador,
    };

    return this.apiService.get(`${endpoints.listarEmpresas}/${cnpj}`, { query });
  }

  consultaSolicitacoes() {
    let query = {
      codigoTransacao: this.codigo.getUniqueId(5),
    };

    return this.apiService.get(endpoints.listarSolicitações, { query });
  }

  consultaDisponibilidadeEntidade(id) {
    let query = { codigoTransacao: generateUUID() };

    return this.apiService.get(
      `${endpoints.garantiaDisponibilidadeEntidade}/${id}`,
      { query }
    );
  }

  consultaDisponibilidade(id) {
    let params = {
      codigoTransacao: this.codigo.getUniqueId(5),
    };

    return this.apiService.post(
      `${
        endpoints.garantiaDisponibilidade
      }/${id}?codigoTransacao=${this.codigo.getUniqueId(5)}`,
      {}
    );
  }

  acompanharProcessoSolicitacao(params = {}) {
    return this.apiService.get(`${endpoints.acompanharProcesso}`, { params });
  }

  consultaDisponibilidadeDPGE() {
    let params = {
      codigoTransacao: this.codigo.getUniqueId(5),
    };
    return this.apiService.get(`${endpoints.consultaDisponibilidadeDPGE}`, {
      params,
    });
  }

  consultaDisponibilidadeGarantiaDPGE(id, cnpjEscolhidoGarantiaDPGE) {
    let params = {
      codigoTransacao: this.codigo.getUniqueId(5),
      cnpjEmpresaEscolhidaCredor: cnpjEscolhidoGarantiaDPGE
    };

    return this.apiService.get(
      `${endpoints.verificarDisponibilidadeDPGE}/${id}`,
      { params }
    );
  }

  listarDadosUsuario(documentoIdentificador: string): Observable<any> {
    return this.apiService.get(`${endpoints.atualizarDados}`);
  }

  updateDadosUsuario(documentoIdentificador: string, body): Observable<any> {
    return this.apiService.put(`${endpoints.atualizarDados}`, body);
  }

  confirmarUpdate(documentoIdentificador: string): Observable<any> {
    return this.apiService.post(`${endpoints.atualizarCognito}`, {});
  }

  statusAndamentoAceite(id) {
    let params = {
      codigoTransacao: this.codigo.getUniqueId(5),
    }

    return this.apiService.get(`${endpoints.acompanharAceite}/${id}/pagamentos/termo/andamento-aceite`, {params});
  }
}
